import map from 'lodash/map';
import pickBy from 'lodash/pickBy';
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export type FilterOptions = {
  filters: {
    start?: string;
    end?: string;
    transaction_type?: string;
    selected_date_filter?: string;
  };
  applyFilters: (f: {
    start?: number | null;
    end?: number | null;
    selected_date_filter?: string;
    transaction_type?: string | null;
  }) => void;
};

const useUtilFilters = (
  current_filters = {},
  options: { pathname?: string } = {}
) => {
  const navigate = useNavigate();
  const location = useLocation();

  const generateFilteredPath = useCallback(
    (new_filters = {}) => {
      const active_filters = pickBy({
        ...current_filters,
        ...new_filters,
      });
      const params = map(active_filters, (v, k) => `${k}=${v}`);
      return `${options?.pathname || location.pathname}?${params.join('&')}`;
    },
    [location, current_filters, options?.pathname]
  );

  const applyFilters = (new_filters: $TSFixMe) => {
    navigate(generateFilteredPath(new_filters));
  };

  return { applyFilters, generateFilteredPath, filters: current_filters };
};

export default useUtilFilters;
